import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import IHttpResponse from '../../interfaces/shared/IHttpResponse';

export enum SendOperativeEmailEnum {
  Unknown,
  Default,
  QuotationBudget,
  MailByProduct
}

export interface ISendEmailData {
  nombre: string;
  email: string;
  idCotizacion: number;
}

export interface ISendOperativeEmail {
  email: string;
  template: string;
  operative: string;
  parameters?: ISendEmailParameter[];
  helioDocuments?: string[];
}

export interface ISendEmailParameter {
  name: string;
  value: string;
}

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  baseUrl = `${environment.baseUrl}`;
  apiUrl = `${environment.ApiNotify}`;
  url: string;

  constructor(private http: HttpClient) {
    this.url = this.baseUrl + this.apiUrl;
  }

  /**
   * @param nombre   Nombre
   * @param email   Email
   * @param idCotizacion   Id of the cotization
   */
   
  sendEmailCotizationData(data: ISendEmailData): Observable<any> {
    return this.http.post<IHttpResponse<ISendEmailData>>(`${this.url}/SendEmailQuotationData`, data);
  }

  sendEmail(body: ISendOperativeEmail) {
    return this.http.post<IHttpResponse<boolean>>(`${this.url}/SendEmail`, body);
  }

}
